import { CanvasLayer, Page, Pages, Root, TextLayer } from "@anaralabs/lector";
import "@/lib/pdf-worker";
import { Loader2 } from "lucide-react";

export function PdfViewer({ source }: { source: string }) {
  return (
    <div className="aspect-[3/4] text-center rounded-lg flex items-center justify-center">
      <Root
        source={source}
        zoomOptions={{
          minZoom: 0.5,
          maxZoom: 10,
        }}
        loader={
          <div className="flex items-center justify-center h-full w-full">
            <Loader2 className="size-8 animate-spin" />
          </div>
        }
        className="w-full h-full border rounded-lg overflow-hidden"
      >
        <Pages className="p-4">
          <Page>
            <CanvasLayer />
            <TextLayer />
          </Page>
        </Pages>
      </Root>
    </div>
  );
}
